import { Product, ProductType, School, Currency, Centre } from "app/shared/model";
import { ProductFilter, SelectionMap } from "app/shared/model/ProductFilter";
import { UnitsFilter } from "app/shared/model/ProductUnitFilter";

export type ProductSelectionState = {
    allProducts: ProductMap,
    centresMap: {[id: string]: Centre}
    allCurrencies: Currency[]
    offeringsBySchool: ProductOfferingsMap
    productFilter: ProductFilter
    schoolFilter: SelectionMap
    allSchools: SchoolOptionMap
    schoolGroups: SchoolGroupMap
    centreGroupOpenState: { [centreCode: string]: boolean }
    unitsFilter: UnitsFilter
    productsInCurrentSchools: Set<string>
    catalogLoadState: OfferingLoadState
}

export type ProductMap = {
    [code: string]: Product
}

export type SchoolGroupMap = {
    [group: string]: SchoolSelectionGroup
}

export type SchoolOptionMap = {
    [schoolId: string]: SchoolOption
}

export type SchoolSelectionGroup = {
    groupCode: string
    title: string
    isOpen: boolean
    itemsSelected: number
    itemsNotSelected: number
}

export type CentreSelectionGroup = {
    centreCode: string
    title: string
    isOpen: boolean
    itemsSelected: number
    itemsNotSelected: number
    countryCode: string
}

export type SchoolOption = {
    name: string,
    code: string,
    countryCode: string,
    currencyCode: string,
    school: School
}

export enum OfferingLoadState {
    None,
    Loading,
    Loaded,
    Errored
}

export type NotLoadedOfferingDetails = {
    loadState: OfferingLoadState.Errored|OfferingLoadState.Loading|OfferingLoadState.None
}

export type LoadedOfferingDetails = {
    loadState: OfferingLoadState.Loaded,
    productCodes: string[]
}

export type OfferingDetails = LoadedOfferingDetails | NotLoadedOfferingDetails;

export type ProductOfferingsMap = {
    [schoolCode: string]: OfferingDetails|undefined
}
